import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function Loading() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" height="200px" flexDirection="column">
      <CircularProgress color="primary" size={24} />
      <Typography variant="body1" sx={{ marginTop: 2, color: 'text.secondary' }}>
        정보를 불러오는 중입니다...
      </Typography>
    </Box>
  );
}
